import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import authRoutes from '@/modules/auth/router';
import inspectionRoutes from '@/modules/inspection/router';

const routes: Array<RouteRecordRaw> = [...authRoutes, ...inspectionRoutes];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
